export default {"src":"/_next/static/image/components/ui/Icon/icons/calendar.77c434eb8ca78c9bc6c398b8b0332bd9.svg","height":18,"width":18};